export const modelList = [
    {
        label: "Design",
        value: "designmasters"
    }, {
        label: "Style",
        value: "stylemasters"
    }, {
        label: "CAD",
        value: "stylemasters"
    }, {
        label: "FG",
        value: "fglivestocks"
    }, {
        label: "SKU",
        value: "skustockmasters"
    }
]

